import { mapActions, mapGetters } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import {
  notEmpty,
  requiredSelectArray
} from '@/modules/_global/variables/rules';

export default {
  mixins: [errors],

  data: () => ({
    rules: {
      type_id: [notEmpty]
    },
    valid: {},
    tilesContents: [],
    disableContentTypes: [
      'Documents',
      'Category',
      'Calendar',
      'MSSNGR Tool',
      'Documents for Building',
      'Documents for Building complex'
    ],
    textFieldContentTiles: [14]
  }),

  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('tile', {
      tilesTypes: 'GET_TILES_TYPES'
    }),
    iconRules() {
      return this.tile.default_icon ? [] : requiredSelectArray;
    },
    defaultIconRules() {
      return this.tile.icon ? [] : [notEmpty];
    },
    isValid() {
      return Object.values(this.valid).every(i => Boolean(i));
    },
    disableContentTypesIds() {
      return this.tilesTypes
        .filter(i => this.disableContentTypes.includes(i.name))
        .map(i => i.id);
    },
    textFieldContent() {
      return this.til;
    }
  },

  mounted() {
    this.getTilesTypes();
  },

  methods: {
    ...mapActions('tile', ['getTilesTypes', 'getTilesContents']),
    setValid(index, value) {
      this.$set(this.valid, index, value);
    },
    cancel() {
      this.$emit('cancel');
    },
    changeType(tileTypeId) {
      this.tile.contentable_id = null;
      this.errors.clear('type_id');
      this.getContent(tileTypeId);
    },
    getContent(tileTypeId) {
      this.getTilesContents({ tileTypeId }).then(({ data }) => {
        this.tilesContents = data.data;
      });
    }
  }
};
